<div mat-dialog-title class="modal-title">
  <mat-icon>person_pin_circle</mat-icon>
  <span>{{ !editMode ? 'Nuevo afiliado' : 'Editar afiliado' }}</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  @if (!editMode && isNewUser) {
    <p>El nuevo afiliado tendrá como contraseña por defecto: <b>ENFAF_Afiliado2023*</b></p>
  }
  <form [formGroup]="affiliateForm" autocomplete="off">
    <div class="form-control">
      <mat-form-field color="primary" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="Email del afiliado" formControlName="email" name="email" autocomplete="off" />
        <mat-error>Email requerido</mat-error>
      </mat-form-field>
    </div>
    @if (!editMode) {
      <div class="verify-email">
        <button
          mat-flat-button
          type="button"
          color="primary"
          (click)="verifyAffiliateEmail()"
          [disabled]="affiliateForm.controls.email.invalid || isVerifyingEmail"
        >
          @if (!isVerifyingEmail) {
            <span>Verificar email</span>
          } @else {
            <mat-spinner class="white-spinner"></mat-spinner>
          }
        </button>
      </div>
    }
    @if (emailVerified) {
      <div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-control">
              <mat-form-field color="primary" appearance="outline">
                <mat-label>Nombre</mat-label>
                <input matInput placeholder="Nombre del afiliado" formControlName="name" name="name" autocomplete="off" />
                <mat-error>Nombre requerido</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-control">
              <mat-form-field color="primary" appearance="outline">
                <mat-label>Apellidos</mat-label>
                <input matInput placeholder="Apellidos del afiliado" formControlName="lastname" name="lastname" autocomplete="off" />
                <mat-error>Apellidos requeridos</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Tipo de afiliado</mat-label>
            <mat-select formControlName="affiliateType" placeholder="Selecciona uno">
              @for (item of affiliateTypes; track item) {
                <mat-option [value]="item.value">
                  {{ item.label }}
                </mat-option>
              }
            </mat-select>
            <mat-error>Tipo de afiliado requerido</mat-error>
          </mat-form-field>
        </div>
        @if (affiliateForm.controls.affiliateType.value === 'freelance') {
          <div class="form-control">
            <mat-form-field color="primary" appearance="outline">
              <mat-label>DNI del autónomo</mat-label>
              <input matInput placeholder="DNI del autónomo" formControlName="affiliateDni" name="affiliateDni" autocomplete="off" />
              <mat-error>DNI requerido</mat-error>
            </mat-form-field>
          </div>
        } @else if (affiliateForm.controls.affiliateType.value === 'company') {
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-control">
                <mat-form-field color="primary" appearance="outline">
                  <mat-label>CIF de la empresa</mat-label>
                  <input matInput placeholder="CIF de la empresa" formControlName="affiliateCif" name="affiliateCif" autocomplete="off" />
                  <mat-error>CIF requerido</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-control">
                <mat-form-field color="primary" appearance="outline">
                  <mat-label>Nombre de la empresa</mat-label>
                  <input matInput placeholder="Nombre de la empresa" formControlName="affiliateCompany" name="affiliateCompany" autocomplete="off" />
                  <mat-error>Nombre de la empresa requerido</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        }
        @if (affiliateForm.controls.affiliateType.value === 'freelance' || affiliateForm.controls.affiliateType.value === 'company') {
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-control">
                <mat-form-field color="primary" appearance="outline">
                  <mat-label>
                    Dirección
                    @if (affiliateForm.controls.affiliateType.value) {
                      <span>
                        {{ affiliateForm.controls.affiliateType.value === 'freelance' ? 'del autónomo' : 'de la empresa' }}
                      </span>
                    }
                  </mat-label>
                  <input matInput placeholder="Dirección" formControlName="affiliateAddress" name="affiliateAddress" autocomplete="off" />
                  <mat-error>Dirección requerida</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-control">
                <mat-form-field color="primary" appearance="outline">
                  <mat-label>Código postal</mat-label>
                  <input matInput placeholder="Código postal" formControlName="affiliatePostalCode" name="affiliatePostalCode" autocomplete="off" />
                  <mat-error>Código postal requerido</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-control">
              <mat-form-field color="primary" appearance="outline">
                <mat-label>Nombre de usuario (Solo se permiten guiones)</mat-label>
                <input matInput placeholder="Nombre de usuario" formControlName="affiliateUsername" name="affiliateUsername" autocomplete="off" />
                <mat-error>Nombre de usuario requerido (Solo se permiten guiones)</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-control">
              <mat-form-field color="primary" appearance="outline">
                <mat-label>Porcentaje de comisión (0 - 100)</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="Porcentaje de comisión"
                  formControlName="affiliateFeePercentage"
                  name="affiliateFeePercentage"
                  autocomplete="off"
                />
                <mat-error>Porcentaje requerido (0 - 100)</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()">Cerrar</button>
  <button mat-flat-button color="primary" (click)="saveAffiliate()" [disabled]="affiliateForm.invalid || isSavingAffiliate">
    @if (!isSavingAffiliate) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
